























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { storeReferensi } from "@/store/modules/referensi";

interface AutocompleteOptions {
  outlined: true;
  label: "";
}

@Component({
  components: {},
})
export default class UnitAllAutoComplete extends Vue {
  @Prop() setUnitAll!: object;

  @Prop({
    default: () => {
      return {
        outlined: true,
        label: null,
      };
    },
  })
  opt: AutocompleteOptions;

  get listUnitAll() {
    return storeReferensi.unitAll;
  }

  // listUnitAll = [
  //   {
  //     id: "1",
  //     nama: "IGD",
  //   },
  //   {
  //     id: "2",
  //     nama: "JAntung",
  //   },
  //   {
  //     id: "3",
  //     nama: "PPRI",
  //   },
  // ];

  unitAll = {};

  list = [];

  searchUnitAll = null;

  loading = false;

  @Watch("setUnitAll")
  valUnitAll(val) {
    this.$emit("unitAll", val);
  }
}
